module.exports = __webpack_public_path__ + "img/orange_007.06a5306d.png";